import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import { format } from 'date-fns';
import useFetch from 'use-http';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { getQueryString } from '@/components/constants/visitsQueryStringBuilder';
import { InfoButton } from '@/components/ui/shared/InfoButton';

export default function E025Table() {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionDispatch = useUserDispatch();
  const userState = useUserState();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState(userState.dateFilter);
  const { get: getVisits, response: getVisitsResponse } = useFetch(
    '/UserAccount/Visits',
  );
  const status = 'ambulatory';

  const fetchData = async (date = dateRange, searchTerm = search) => {
    setIsLoading(true);
    sessionDispatch({
      type: 'UPDATE',
      data: { dateFilter: date },
    });

    const result = await getVisits(
      getQueryString(date, searchTerm, status, undefined, userState.espbiEsi),
    );

    if (getVisitsResponse.ok) {
      setData(_.orderBy(result, ['date'], ['desc']));
    } else {
      // Optional: handle error or log
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [dateRange, userState?.espbiEsi]);

  return (
    <DataTable
      title="Gydytojų konsultacijos"
      loading={isLoading}
      columns={columns({ history })}
      data={data}
      filterableColumns={['visitTitle', 'department', 'paymentStatus', 'date']}
      onRowClick={(row) =>
        history.push('/userAccount/visits/details', {
          visit: row,
          fromE025: true,
        })
      }
    />
  );
}

const columns = ({ history }) => [
  {
    accessorKey: 'visitTitle',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="KONSULTACIJA" />
    ),
    cell: ({ row }) => (
      <span className="font-medium max-w-[400px] truncate capitalize">
        {row.original.visitTitle}
      </span>
    ),
  },
  {
    accessorKey: 'date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="DATA" />
    ),
    cell: ({ row }) => {
      const rawDate = new Date(row.original.date);
      const isMidnight =
        rawDate.getUTCHours() === 0 && rawDate.getUTCMinutes() === 0;

      return (
        <span className="text-muted-foreground">
          {isMidnight
            ? format(rawDate, 'yyyy-MM-dd')
            : format(rawDate, 'yyyy-MM-dd HH:mm')}
        </span>
      );
    },
  },
  {
    accessorKey: 'department',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="SKYRIUS / ADRESAS" />
    ),
    cell: ({ row }) => {
      const { department, departmentAddress } = row.original;
      return (
        <span className="text-muted-foreground">
          {department}
          {departmentAddress ? `, ${departmentAddress}` : ''}
        </span>
      );
    },
  },
  {
    accessorKey: 'paymentStatus',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="STATUSAS" />
    ),

    cell: ({ row }) => {
      const display = row.original.paymentStatus;
      let variant = 'neutral';
      if (display === 'Įvykusi') variant = 'success';
      else if (display === 'Neįvykęs') variant = 'fail';
      return <Badge variant={variant}>{display}</Badge>;
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex gap-2 justify-end">
        <InfoButton
          onClick={() =>
            history.push('/userAccount/visits/details', {
              visit: row.original,
              fromE025: true,
            })
          }
        >
          {' '}
          Informacija
        </InfoButton>
      </div>
    ),
  },
];
